export function toCodeList(value) {
    if (value == null || value === '') return []
    let parsed = value
    if (typeof parsed === 'string') {
        try {
            parsed = JSON.parse(parsed)
        } catch {
            return parsed ? [parsed] : []
        }
    }
    if (Array.isArray(parsed)) return parsed
    if (typeof parsed === 'object') {
        return Object.keys(parsed)
            .filter(key => key !== '__ob__')
            .map(key => parsed[key])
    }
    return []
}

export function extractCode(entry) {
    if (entry == null || entry === '') return ''
    if (typeof entry === 'string' || typeof entry === 'number') {
        return String(entry)
    }
    return entry.code || entry.workOrder || entry.bom || ''
}

export function buildWorkOrdersAndBomsString(packingList = {}) {
    const seen = new Set()
    const codes = []
    const addCode = raw => {
        const code = extractCode(raw)
        if (!code || seen.has(code)) return
        seen.add(code)
        codes.push(code)
    }
    ;(packingList.packages || []).forEach(pkg => {
        ;(pkg.items || []).forEach(item => {
            addCode(item.workOrder)
            addCode(item.bom)
        })
        addCode(pkg.packageBOM)
    })
    toCodeList(packingList.selectedWorkOrders).forEach(addCode)
    toCodeList(packingList.reservedWorkOrders).forEach(addCode)
    toCodeList(packingList.selectedBOMs).forEach(addCode)
    return codes.join(', ')
}
